// extracted by mini-css-extract-plugin
module.exports = {"user_button":"logout_user_button__1nV1p menu_button","action_button":"logout_action_button__1Ahag"};